import { CardInputWithType, ECardType, LinkInput } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

const importKey = 'Name';

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const cat1 = 'a7246190-74f7-4050-9add-787f03ccd176';
    const cat2 = '3e0a7409-7c6c-4e62-b345-608407c72e5c';
    const cat3 = 'bbb2ae26-519c-4ee7-87a3-a4d49ff840eb';

    let desc = '**💡 Exponáty:**\n\n';

    for (let i = 1; i <= 10; i++) {
        if (row['Title' + i]) {
            // mutationPayload.cards.push({
            //     type: ECardType.TEXT,
            //     info: {
            //         title: row['Title' + i],
            //         description: row['Desc' + i]
            //     }
            // });
            let d = '';
            if (
                row['Desc' + i]?.toLowerCase() !== 'ne' &&
                row['Desc' + i]?.toLowerCase() !== '-' &&
                row['Desc' + i]?.toLowerCase() !== 'upřesníme' &&
                row['Desc' + i]?.toLowerCase() !== ''
            ) {
                d = row['Desc' + i] + '\n\n';
            } else {
                d = '\n';
            }
            desc += '**' + row['Title' + i] + '**\n' + d;
        }
    }

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[importKey],
            header: {
                title: row['Name'],
                text: desc
                // imageUrl: row['img'],
                // imageStyleId: 'stretch'
            }
        },
        cards: []
    };

    const hasLinkCard = row['Link'];
    const linkCard: CardInputWithType = {
        type: ECardType.LINK,
        links: (() => {
            const links: LinkInput[] = [];

            links.push({
                title: 'Webová stránka',
                url: row['Link']
            });

            return links;
        })()
    };

    if (hasLinkCard) {
        mutationPayload.cards.push(linkCard);
    }

    mutationPayload.cards.push({
        type: ECardType.TEXT,
        info: {
            title: row['Name'],
            description: row['Description']
        }
    });

    let category;
    if (row['Category'] === '1') {
        category = cat1;
    }
    if (row['Category'] === '2') {
        category = cat2;
    }
    if (row['Category'] === '3') {
        category = cat3;
    }

    mutationPayload.addToCategoriesId = [category];

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[importKey]?.toLowerCase();
}

export const dobrodruzstviImportMethods = { duplicateChecker, parser };
